import { StarterKit } from '@tiptap/starter-kit';
import { Placeholder } from '@tiptap/extension-placeholder';
import { Underline } from '@tiptap/extension-underline';
import { TextAlign } from '@tiptap/extension-text-align';
import { Heading } from '@tiptap/extension-heading';
import { TaskItem } from '@tiptap/extension-task-item';
import { TaskList } from '@tiptap/extension-task-list';
import { CharacterCount } from '@tiptap/extension-character-count';
import { ListItem } from '@tiptap/extension-list-item';
import { Link } from '@tiptap/extension-link';
import { Superscript } from '@tiptap/extension-superscript';
import { Subscript } from '@tiptap/extension-subscript';
import TableRow from '@tiptap/extension-table-row';
import { SlashCommand } from './SlashCommandExtension';
import FontSize from './FontSizeExtension';
import TextStyle from '@tiptap/extension-text-style';
import { ColorExtension } from './ColorExtension';
import Highlight from '@tiptap/extension-highlight';
import ImageUpload from './ImageUpload';
import ImageBlock from './ImageBlock';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import { TableWithColgroup } from './TableWithColgroup';
import { TableCellWithColwidth } from './TableCellWithColwidth';
import { TableHeaderWithColwidth } from './TableHeaderWithColwidth';
import { Mathematics } from '@tiptap/extension-mathematics';
import type { Node as PMNode } from '@tiptap/pm/model';

interface TipTapExtensionKitOption {
  ai: {
    openGenerateWorksheetModal: () => void;
    openTableInsertDialog: () => void;
    openImageUploadDialog: () => void;
  };
  mathEditor?: {
    onInlineMathClick: (node: PMNode, pos: number) => void;
    onBlockMathClick: (node: PMNode, pos: number) => void;
  };
  disabledSlashCommands?: string[];
}

export const TipTapExtensionKit = ({ ai, mathEditor, disabledSlashCommands }: TipTapExtensionKitOption) => [
  Mathematics.configure({
    inlineOptions: mathEditor ? { onClick: mathEditor.onInlineMathClick } : undefined,
    blockOptions: mathEditor ? { onClick: mathEditor.onBlockMathClick } : undefined,
  }),
  StarterKit.configure({
    heading: false,
    listItem: false,
    horizontalRule: false,
  }),
  Underline,
  Placeholder,
  TextAlign.configure({
    types: ['heading', 'paragraph'],
  }),
  Heading.configure({
    levels: [1, 2, 3],
  }),
  TaskList,
  TaskItem.configure({
    nested: true,
  }),
  ListItem,
  CharacterCount.configure({
    limit: 10000,
  }),
  SlashCommand.configure({ ai, disabledCommands: disabledSlashCommands, mathEditor }),
  TextStyle,
  FontSize,
  Link.configure({
    openOnClick: false,
  }),
  ColorExtension,
  Highlight.configure({ multicolor: true }),
  ImageUpload,
  ImageBlock,
  HorizontalRule,
  Superscript,
  Subscript,
  TableWithColgroup.configure({
    resizable: true,
    HTMLAttributes: {
      class: 'tiptap-table',
    },
  }),
  TableRow,
  TableHeaderWithColwidth,
  TableCellWithColwidth,
];

export default TipTapExtensionKit;
